import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'trpx-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  errorModalRef?: BsModalRef;

  @Input() errorData: any;
  @Input() autoClose: boolean = false;
  @Input() autoCloseTime: number = 300000;
  @Input() modalColor: any;

  constructor(public modalRef: BsModalRef) {
    console.log("modalColor", this.modalColor)
  }

  ngOnInit(): void {
    if (this.autoClose) {
      setTimeout(() => {
        this.close();
      }, this.autoCloseTime);
    }
  }

  getModalClass(): string {
    switch (this.modalColor) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return ''; // No class if modalColor is not recognized
    }
  }

  close() {
    this.modalRef.hide();
  }
}
